import { FC, useEffect, useRef, useState } from 'react';
import { DefaultLayoutPadding } from '../../../constants/Layout';
import theme, { BorderColors } from '../../../theme';
import { FlexContainer } from '../Container';
import { Description, Error, InputTextArea, Label } from '../InputText/style';

export interface TextAreaProps {
  borderColor?: BorderColors;
  name: string;
  label?: string;
  description?: string;
  error?: string;
  rows?: number;
  maxHeight?: number;
  [x: string]: any;
}

const TextArea: FC<TextAreaProps> = ({
  borderColor,
  error,
  name,
  label,
  description,
  rows = 5,
  maxHeight = 200,
  ...otherProps
}) => {
  const inputRef = useRef(null);
  const [rootHeight, setRootHeight] = useState('auto');
  const [textAreaHeight, setTextAreaHeight] = useState('auto');
  useEffect(() => {
    if (inputRef.current && inputRef.current.scrollHeight < maxHeight) {
      setRootHeight(`${inputRef.current.scrollHeight}px`);
      setTextAreaHeight(`${inputRef.current.scrollHeight}px`);
    }
  }, [maxHeight]);

  return (
    <FlexContainer style={{ position: 'relative' }} flexDirection="column">
      {label && <Label htmlFor={name}>{label}</Label>}
      {description && <Description>{description}</Description>}
      <InputTextArea
        style={{ minHeight: rootHeight, maxHeight: `${maxHeight}px`, height: textAreaHeight }}
        rows={rows}
        borderColor={borderColor}
        error={error}
        name={name}
        {...otherProps}
        ref={inputRef}
      />
      {error && (
        <Error style={{ position: 'absolute', top: '13%', paddingLeft: theme.spacing[DefaultLayoutPadding] }}>
          {error}
        </Error>
      )}
    </FlexContainer>
  );
};

export default TextArea;
